<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <h1 class="not-found-code">404</h1>
      <div class="not-found-icon">
        <span>!</span>
      </div>
      <h2 class="not-found-title">内容已经找不到了</h2>
      <p class="not-found-desc">您访问的内容可能已被删除、下架或输入的链接有误</p>
      <div class="not-found-actions">
        <button class="not-found-btn not-found-btn--primary" @click="goHome">返回首页</button>
        <button class="not-found-btn not-found-btn--text" @click="goBack">返回上一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.replace('/home');
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #ffffff;
}

.not-found-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px;
  transform: scale(1.15);
}

.not-found-code {
  margin: 0;
  font-size: 180px;
  font-weight: 700;
  color: #b0000b;
  line-height: 1;
  letter-spacing: 12px;
}

.not-found-icon {
  width: 96px;
  height: 96px;
  margin: 32px 0 40px;
  border: 6px solid #b0000b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.not-found-icon span {
  font-size: 60px;
  font-weight: 700;
  color: #b0000b;
}

.not-found-title {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 700;
  color: #333333;
  line-height: 1.4;
}

.not-found-desc {
  margin: 0 0 40px;
  font-size: 20px;
  color: #999999;
  line-height: 1.6;
}

.not-found-actions {
  display: flex;
  align-items: center;
  gap: 32px;
}

.not-found-btn {
  font-size: 18px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.not-found-btn:hover {
  opacity: 0.85;
}

.not-found-btn--primary {
  min-width: 160px;
  height: 52px;
  padding: 0 32px;
  background-color: #b0000b;
  color: #ffffff;
  border: none;
  border-radius: 8px;
}

.not-found-btn--text {
  background-color: transparent;
  color: #666666;
  border: none;
}
</style>
